<template>
  <modal name="kirara-dialog" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true" @before-close="handleBeforeClose">
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeKiraraDialog" icon="el-icon-circle-close" style="font-size: 2rem;"
        type="text"></el-button>
    </div>
    <div class="setting" v-if="permissionType == 29">
      <div class="setting-item" style="text-align:center;">
        <p style="font-size: 150%;">もうすぐで完了するよ！</p>
        <p style="font-size: 140%;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/kirara_yagish_logo.png" style="width:100%">
          </p>
        </div>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">ご同意いただいた方には追って連絡がいき</p>
          <p style="font-size: 140%;">ますので、ご確認お願いいたします！</p>
        </div>
        <p>
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a><br />
          (株)トライトキャリアの<a href="https://kirara-career.co.jp/sitepolicy/" target="_blank">利用規約</a>、<a
            href="https://kirara-career.co.jp/handling/" target="_blank">個人情報の取扱い</a><br />
          ㈱アド・トップの<a href="https://adtop-web.com/saiplus/agent/careerup/tos.html" target="_blank">利用規約</a>、<a
            href="https://adtop-web.com/privacypolicy.html" target="_blank">個人情報保護方針</a><br />
          アルバイトEXの<a href="https://arubaito-ex.jp/terms" target="_blank">利用規約</a>、<a
            href="https://arubaito-ex.jp/privacy" target="_blank">個人情報保護方針</a>
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;">
          <img src="/static/renew_img/check_icon.png" style="width:40px">上記規約に同意して、会員登録を希望する
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="false">
        <p style="font-size: 140%;">
          <el-checkbox v-model="isAgree"
            style="-moz-transform:	scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">規約に同意して無料相談や<br>求人受取、会員登録を希望する</el-checkbox>
        </p>
        <br />
      </div>
      <div class="text-center" style="padding:10px">
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isKiraraSended == false"
          style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          @click="$eventHub.$emit('send-kirara-consult');">看護師を希望</el-button>
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isKiraraSended == true"
          style="background-color:#0F9934;border-color:#0F9934;" @click="closeKiraraDialog();">送信しました</el-button>
        <br />
      </div>
      <div class="text-center" style="padding:10px" v-if="false">
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isMedlySended == false"
          style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          @click="$eventHub.$emit('send-medley-consult-kirara');">その他の師業を希望</el-button>
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isMedlySended == true"
          style="background-color:#0F9934;border-color:#0F9934;" @click="closeKiraraDialog();">送信しました</el-button>
        <br />
      </div>
      <div class="text-center" style="padding:10px">
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isAdtopSended == false"
          style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          @click="$eventHub.$emit('send-adtop-consult-kirara');">その他の正社員を希望</el-button>
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isAdtopSended == true"
          style="background-color:#0F9934;border-color:#0F9934;" @click="closeKiraraDialog();">送信しました</el-button>
        <br />
      </div>
      <div class="text-center" style="padding:10px">
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isJigenSended == false"
          style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          @click="$eventHub.$emit('send-jigen-consult-kirara');">アルバイトを希望</el-button>
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isJigenSended == true"
          style="background-color:#0F9934;border-color:#0F9934;" @click="closeKiraraDialog();">送信しました</el-button>
        <br />
      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 1">
      <div style="text-align: center;">
        <p style="font-size: 120%;">ダウンロードが完了しました！！！</p>
        <p style="font-size: 90%; padding-bottom: 5px;">作成した履歴書からおすすめの求人をご紹介！</p>
        <div style="display: inline-block; min-width: 100%; text-align: center;">
          <p style="font-size: 90%; font-weight: bold;">保育士<span style="font-size: 80%;">の</span>正社員転職<span
              style="font-size: 80%;">を</span>お考えの方<span style="color:rgb(246, 11, 38)">必見！</span></p>
          <p style="font-size: 90%; font-weight: bold;">※保育士資格をお持ちの方限定※</p>
          <p style="font-size: 140%;">
            <img src="/static/renew2_img/kirara_yagish_logo_20230809.png" style="width:90%">
          </p>
        </div>
        <div style="display: inline-block; min-width: 100%; text-align: center;">
          <p style="font-size: 110%; padding-bottom: 30px;"><span
              style="background: linear-gradient(transparent 60%, #FFCCCC 50%);">満足度93%の保育士転職サービス</span>のプロに
            <br>履歴書・経歴書チェック【無料】を申し込みませんか？
            <br>保育園運営の経験から転職成功者のノウハウをお伝えします。
          </p>
        </div>
        <div>
          <div style="margin-bottom: 40px;"><!--規約等とボタンのセット-->
            <!--ここにチェックボックス入れる-->
            <p style="padding-bottom: 5px;font-size: 60%;">
              <el-checkbox v-model="isAgree"
                style="-moz-transform: scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">
              </el-checkbox>
              キララサポートの
              <a href="https://kirara-support.jp/hoiku/terms" class="" id="footer-link-terms" target="_blank">利用規約</a>・
              <a href="https://kirara-support.jp/hoiku/privacy" class="" id="footer-link-policy"
                target="_blank">個人情報の取扱い</a>
              に同意する
            </p>
            <div style="width: 90%; margin: 0 auto;">
              <!--<p style="font-size: 120%; font-weight: bold; padding-right: 15px;">看護師を希望</p>-->

              <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
                v-if="isKiraraSended == false && isAgree == false"
                style="background-color: rgb(255, 255, 255); border-color: rgb(246, 11, 38); font-size: 120%;color:rgb(0, 0, 0)"
                @click="$eventHub.$emit('send-kirara-consult');"><span
                  style="font-size: 80%; line-height: 1rem;">保育転職のプロに<br>無料で添削してもらう</span></el-button>
              <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
                v-else-if="isKiraraSended == false && isAgree == true"
                style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); font-size: 120%;"
                @click="$eventHub.$emit('send-kirara-consult');"><span
                  style="font-size: 80%; line-height: 1rem;">保育転職のプロに<br>無料で添削してもらう</span></el-button>
              <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
                v-else-if="isKiraraSended == true" style="background-color:#0F9934;border-color:#0F9934;"
                @click="closeKiraraDialog();"><span style="font-size: 80%; line-height: 1rem;">送信しました</span></el-button>

              <p style="font-size: 80%;">※(株)モード・プランニング・ジャパンへの登録</p>
            </div>
          </div>
          <div style="display: inline-block; min-width: 100%; text-align: center;">
            <p style="font-size: 120%;">ご同意いただいた方には、
              <br><span style="font-weight: bold;">電話もしくはメール</span>にてご連絡いたします。
            </p>
            <p style="font-size: 80%;">※会員登録へのボタンを押した場合、
              <br>規約に同意したとみなします。
            </p>
            <p style="margin: 20px 40px;">（yagishの
              <a href="/terms" class="" id="footer-link-terms" target="_blank">利用規約</a>・
              <a href="/privacy" class="" id="footer-link-policy" target="_blank">個人情報保護方針</a>）
              <br>※会員登録へのボタンを押した場合、規約に同意したとみなします。
              <br>※yagishの採用への応募ではありません。
            </p>
          </div>

        </div>

      </div>
    </div>
    <div class="text-right">
      <el-button @click="closeKiraraDialog">閉じる</el-button>
    </div>
  </modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import { emitRtDialogClosedWithoutSubmit, wrapMittPopupHandler } from '@/plugins/emitter'
export default {
  components: {
  },
  data: function () {
    return {
      isMypage: false,
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isKiraraSended: false,
      isMedlySended: false,
      isAdtopSended: false,
      isJigenSended: false,
      fullscreenLoading: false,
      username: '',
      clientId: 'kirara_mail',
      baite_title: 'バイト',
      isAgree: false,
      medleyID: 7,
      medleyPCLnks: {
        1: 'https://job-medley.com/lp/hh/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=hh_yagish',
        2: 'https://job-medley.com/lp/cw/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=cw_yagish',
        3: 'https://job-medley.com/lp/apo/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=apo_yagish',
        4: 'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        5: 'https://job-medley.com/lp/dh/18021/pc/?utm_source=yagish&utm_medium=cpa&utm_campaign=dh_yagish',
        6: 'https://job-medley.com/lp/da/18021/pc/?utm_source=yagish&utm_medium=cpa&utm_campaign=da_yagish',
        7: 'https://job-medley.com/lp/ans/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=ans_yagish',
        8: 'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        9: 'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        10: 'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish'
      },
      medleySPLnks: {
        1: 'https://job-medley.com/lp/hh/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=hh_yagish',
        2: 'https://job-medley.com/lp/cw/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=cw_yagish',
        3: 'https://job-medley.com/lp/apo/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=apo_yagish',
        4: 'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        5: 'https://job-medley.com/lp/dh/18021/sp/?utm_source=yagish&utm_medium=cpa&utm_campaign=dh_yagish',
        6: 'https://job-medley.com/lp/da/18021/sp/?utm_source=yagish&utm_medium=cpa&utm_campaign=da_yagish',
        7: 'https://job-medley.com/lp/ans/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=ans_yagish',
        8: 'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        9: 'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        10: 'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish'
      }
    }
  },
  created: function () {
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
      // console.log all the kay/value pairs
      if (key === 'basicData') {
        app.username = value.lastName + '_' + value.firstName
      }
    }, function (err) {
      if (!err) {
        console.log('Iteration has completed')
      }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openKiraraDialog: function (id, html, isMypage = false) {
      this.isMypage = isMypage
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.$modal.show('kirara-dialog')
      this.clearLocalStorageConfirmVisible = false

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'kirara_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, { timeout: 60000 })
      this.$iterateStorage(function (value, key, iterationNumber) {
        // console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
      }, function (err) {
        if (!err) {
          console.log('Iteration has completed')
        }
      })
    },
    closeKiraraDialog: function () {
      this.$modal.hide('kirara-dialog')
      this.clearLocalStorageConfirmVisible = false
      // this.$router.push('/mypage')
    },
    handleBeforeClose: function (event) {
      if (!this.isKiraraSended) {
        this.$eventHub.$emit('update_rt_condition', this.clientId, this.permissionType)
        emitRtDialogClosedWithoutSubmit()
      }
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendKiraraConsult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'kirara_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '1')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendKirara, formData, { timeout: 60000 })
        .then(function (response) {
          app.isKiraraSended = true
          app.$globalVar.eventTag()
          app.$eventHub.$emit('update_rt_condition', app.clientId, app.permissionType)
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-kirara-consult', this.sendKiraraConsult)
    // emitGlobalVarPopupDialog → mitt 直購読（GLOBAL_VAR_POPUP_EVENT_TYPES / emitter.js）
    this._mittGVPopup_openKiraraDialog = wrapMittPopupHandler(this, 'openKiraraDialog')
    this.$emitter.on('open-kirara-dialog', this._mittGVPopup_openKiraraDialog)
    this.$eventHub.$on('popstate', this.closeKiraraDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-kirara-consult', this.sendKiraraConsult)
    this.$emitter.off('open-kirara-dialog', this._mittGVPopup_openKiraraDialog)
    this.$eventHub.$off('popstate', this.closeKiraraDialog)
  }
}
</script>
